module.exports = __webpack_public_path__ + "img/icon7.f87146f6.png";